<script setup>
import DpHeader from './DpHeader';
import DpWrapper from './DpWrapper';
import { storeToRefs } from 'pinia'
import { useEnvStore } from '@dutypay/store-modules'
const envStore = useEnvStore()
const {globalLoading} = storeToRefs(envStore)
</script>
<script>
const tests = [
  {
    title: ""
  }
  // TODO: menuItems
  // TODO: hasCompanySwitch
  // TODO: Slot reminder
  // TODO: Slot default
];

export default {
  name: "DpApplicationContainer",
  description: "Holds the content of an application. Makes use of DpContent to render the wrapper and DpHeader.",
  props: {
    menuItems: { type: Array },
    hasCompanySwitch: { type: Boolean, default: true }
  },
  // tests,
}
</script>

<template>
  <div v-loading.fullscreen.lock="globalLoading">
    <DpHeader :menuItems="menuItems" :hasCompanySwitch="hasCompanySwitch"></DpHeader>
    <DpWrapper>
      <slot name="reminder"></slot>
      <slot></slot>
    </DpWrapper>
  </div>
</template>

<style scoped lang="scss">
</style>

<i18n>
{
}
</i18n>
